jQuery( document ).ready( function ( $ ) {
  // Scroll into position plugin init
  AOS.init({
    offset: 200
  });

  //Flickity Options and init
  $('#slideshow').flickity({
    wrapAround: true,
    adaptiveHeight: true,
    imagesLoaded: true,
    prevNextButtons: false,
    fade: true,
    autoPlay: 5000
  });

  $('.flickity-prev-next-button.previous').on( 'click', function() {
    $('#slideshow').flickity('previous');
  });

  $('.flickity-prev-next-button.next').on( 'click', function() {
    $('#slideshow').flickity('next');
  });

  //Menus
  //++=====================================================================

  $( '.menu-btn' ).click( function ( e ) { // hide/show menu for mobile
    e.preventDefault();
    if ( $( this ).hasClass( 'active' ) ) {
      $( this ).removeClass( 'active' );
      $( '.full-menu' ).removeClass( 'active' );
      $( '.full-menu .menu-btn' ).removeClass( 'active' );
    } else {
      $( '.full-menu' ).addClass( 'active' );
      $( '.full-menu .menu-btn' ).addClass( 'active' );
    }
  } );

  $( '.single-portfolio .accordion h2' ).click( function () {
    $( '.accordion' ).removeClass('active');

    $( this ).parents('.accordion').addClass('active');
  } );

  $( '.post-type-archive-case-study .accordion h2, .comments-container .accordion h2' ).click( function () {
    $( this ).parents('.accordion').toggleClass('active');
  } );

  $( '.widget h2' ).click( function () {
    $( this ).parents('.widget').toggleClass('active');
  } );

  $('.open-bio').magnificPopup({
    closeBtnInside: true,
    fixedContentPos:true,
  });



  // Tab behavior
  $('.tab-link').click(function(){
    var tab_id = $(this).attr('data-tab');

    $(this).parents('.accordion-txt').find('.tab-link').removeClass('current');
    $(this).parents('.accordion-txt').find('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });

  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('.open-bio')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
} );


